import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { connect } from 'pwa-helpers';
import store from '../../../store/store';
import { BaseComponent } from '../../base-component/base-component';
import { Modal } from '../../modal/modal';
import emit from '../../../common/events';

/**
 * Component to display a Learning Technology Representative card.
 */
@customElement('mhecomm-ltr-card')
export class LearningTechnologyRepresentativeCard extends connect(store)(BaseComponent) {

  /**
   * LTR first name.
   */
  @property({type: String})
  firstName: string = '';

  /**
   * LTR last name.
   */
  @property({type: String})
  lastName: string = '';

  /**
   * LTR area of interest, formatted as a comma-separated string.
   */
  @property({type: String})
  area: string = '';

  /**
   * LTR email address.
   */
  @property({type: String})
  email: string = '';

  /**
   * LTR phone number.
   */
  @property({type: String})
  phone: string = '';

  renderComp() {
    return html`
      <div class="col my-2">
        <div class="card rounded bg-white shadow h-100">
          <div class="card-body">
            <h4 class="fw-semibold mb-3">${this.firstName} ${this.lastName}</h4>
            <div class="fw-bold mb-1">Areas of Interest</div>
            <p class="card-text">${this.getFormattedArea()}</p>
            <button class="btn btn-outline-primary" type="button" @click="${() => this.openModal()}">
              <uxt-icon icon="tablet" aria-hidden="true"></uxt-icon>
              View Contact Info
            </button>
          </div>
        </div>
      </div>
    `;
  }

  private getFormattedArea() {
    return this.area.replace(/,/g, ', ');
  }

  private openModal() {
    this.emitAnalyticsEvent('ltr-contact-info-click');
    const modal: Modal = new Modal({
      header: 'Contact Info',
      reversedFooter: true,
      body: {template: this.getModalBody()},
      modalContext: {
        componentRef: 'ltr-contact-info',
        componentRefData: this.getAnalyticsDetails('ltr-contact-info-modal-close')
      },
      isModalCentered: true,
      disableFooter: true
    });
    modal.open();
  }

  private emitAnalyticsEvent(eventName: string) {
    emit({
      element: this,
      name: eventName,
      detail: this.getAnalyticsDetails(eventName)
    });
  }

  private getAnalyticsDetails(eventName: string) {
    return {
      eventName: eventName,
      repName: `${this.firstName} ${this.lastName}`,
      areasOfInterest: this.getFormattedArea(),
    };
  }

  private getModalBody() {
    return html`
      <div class="row mx-0 mb-3">
        <div class="row fw-bold">${this.firstName} ${this.lastName}</div>
        <div class="row">Phone: ${this.phone}</div>
        <div class="row">Email: ${this.email}</div>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-ltr-card': LearningTechnologyRepresentativeCard;
  }
}
